<template>
  <div>
    <div class="ui form">
      <div class="fields">
        <div class="wide field" :class="{ eight: (currentControlAccessCard.usuarioSistema === '0'), sixteen: (currentControlAccessCard.usuarioSistema != null && currentControlAccessCard.usuarioSistema !== '0') }">
          <label>{{ $t("components.userForm.Usuario_sistema") }}</label>
          <div class="ui input">
            <select class="ui dropdown fluid" v-model="currentControlAccessCard.usuarioSistema" @change="onChangeSelectUser">
              <option value="0">{{ $t("components.userForm.Seleccione_un_usuario") }}</option>
              <option v-for="user in allUsers" v-bind:key="user._id" :value="user._id">{{ user.name + ' (' + user.login + ')' }}</option>
            </select>
          </div>
        </div>
        <div class="eight wide field" v-if="(currentControlAccessCard.usuarioSistema === '0')">
          <label>{{ $t("components.userForm.Descripcion") }}</label>
          <div class="ui input">
            <input type="text" v-model="currentControlAccessCard.description">
          </div>
        </div>
      </div>

      <div class="fields">
        <div class="four wide field">
          <label>{{ $t("components.userForm.ID_usuario") }}</label>
          <div class="ui input">
            <input type="text" v-model="currentControlAccessCard.userid">
          </div>
        </div>
        <div class="four wide field">
          <label>{{ $t("components.userForm.Permiso") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="currentControlAccessCard.permiso">
              <option value="N">{{ $t("components.userForm.Permiso_normal") }}</option>
              <option value="M">{{ $t("components.userForm.Permiso_mantenimiento") }}</option>
            </select>
          </div>
        </div>
        <div class="four wide field" >
          <label>{{ $t("components.userForm.Caducidad") }}</label>
          <div class="ui calendar" id="fecha-caducidad">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text">
            </div>
          </div>
        </div>
        <div class="four wide field" >
          <label>{{ $t("components.userForm.Habilitado") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="currentControlAccessCard.enabled">
              <option value="false">{{ $t("components.common.No") }}</option>
              <option value="true">{{ $t("components.common.Si") }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="ui styled accordion" style="width:100%">
        <div class="title active" style="background: #8bb040;color: white;">
          <i class="dropdown icon"></i>
          {{ $t("components.userForm.Accesos_a_salas") }}
          <span v-if="currentControlAccessCard.controllers.length">( {{ currentControlAccessCard.controllers.length }} )</span>
        </div>
        <div class="content active">
          <div v-for="controllerUser in currentControlAccessCard.controllers" v-bind:key="controllerUser">
            <div class>
              <div class="active content" style="padding-top:0px; padding-bottom:0px">
                <div class="fields">
                  <div class="fourteen wide field" >
                    <select class="ui dropdown fluid" v-bind:id="'selectedControllerUser' + controllerUser">
                      <option value="0">{{ $t("components.userForm.Seleccione_una_sala") }}</option>
                      <option v-for="controller in controllersOfUser" v-bind:key="controller._id" :value="controller._id">{{ controller.description }}</option>
                    </select>
                  </div>
                   <div class="two wide field" style="padding-top:5px;">
                    <button class="circular basic ui icon button red mini floated right" @click="removeAccesoSala(controllerUser)">
                      <i class="remove icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="circular ui icon button olive mini" @click="addAccesoSala()">
            <i class="icon add"></i>
          </button>
        </div>
      </div>
    </div>
    <h2 class="ui dividing header"></h2>
    <button class="ui olive labeled icon button" style="float:right" @click="save()">
      <i class="icon add"></i>{{ $t('components.common.Guardar') }}
    </button>
    <router-link class="item" to="/controlAccessCards">
      <button class="ui labeled icon button" style="float:right">
        <i class="remove icon"></i> {{ $t('components.common.Volver') }}
      </button>
    </router-link>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';

export default {
  name: 'ControlAccessCardForm',
  data: function () {
    return {
      moment: Vue.moment,
      currentControlAccessCard: { usuarioSistema: '0', description: '', userid: '', permiso: 'N', controllers: [], caducidad: null, enabled: true },
      allControllers: [],
      allUsers: [],
      currentUser: { _id: '0' },
      controllersByUsers: [],
      controllersOfUser: [],
    };
  },
  methods: {
    calendarFormatDate: function (date, settings) {
      return this.moment(date).locale(this.$i18n.locale).format('LL');
    },
    refresh: function () {
      let getUrl = "/controlAccessCard";

      if (this.$route.params.idControlAccessCard != null) {
        getUrl += "/" + this.$route.params.idControlAccessCard;
      }

      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get(getUrl).then(response => {
        if (response) {
          $('#fecha-caducidad').calendar({
            type: 'date',
            text: this.$i18n.t('components.common.calendar'),
            ampm: false,
            firstDayOfWeek: 1,
            formatter: {
              date: this.calendarFormatDate
            }
          });

          this.allControllers = response.data.allControllers;

          this.allControllers.sort((c1, c2) => {
            if (c1.description < c2.description) {
              return -1;
            } else if (c1.description > c2.description) {
              return 1;
            } else {
              return 0;
            }
          });

          this.allUsers = response.data.allUsers;
          this.controllersByUsers = response.data.controllersByUsers;

          if (response.data.userControlAccesos != null) {
            this.currentControlAccessCard = response.data.userControlAccesos;

            this.currentControlAccessCard.controllers.sort((c1, c2) => {
              const controller1 = this.allControllers.find(c => c._id === c1);
              const controller2 = this.allControllers.find(c => c._id === c2);

              if (controller1 == null || controller2 == null) {
                return 0;
              }

              if (controller1.description < controller2.description) {
                return -1;
              } else if (controller1.description > controller2.description) {
                return 1;
              } else {
                return 0;
              }
            });

            if (this.currentControlAccessCard.usuarioSistema == null) {
              this.currentControlAccessCard.usuarioSistema = "0";
            }

            if (this.currentControlAccessCard.caducidad != null) {
              $('#fecha-caducidad').calendar('set date', (new Date(this.currentControlAccessCard.caducidad)));
            }

            this.controllersOfUser = [];

            if (this.currentControlAccessCard.usuarioSistema == null) {
              this.controllersOfUser = this.allControllers;
            } else {
              if (this.controllersByUsers[this.currentControlAccessCard.usuarioSistema] != null) {
                this.controllersByUsers[this.currentControlAccessCard.usuarioSistema].forEach((controller) => {
                  this.controllersOfUser.push(this.allControllers.find((c) => c._id === controller));
                });
              } else {
                this.controllersOfUser = this.allControllers;
              }
            }

            this.controllersOfUser.sort((c1, c2) => {
              if (c1.description < c2.description) {
                return -1;
              } else if (c1.description > c2.description) {
                return 1;
              } else {
                return 0;
              }
            });

            Vue.nextTick(() => {
              for(let i = 0; i < this.currentControlAccessCard.controllers.length; i++) {
                if (this.controllersOfUser.find((c) => c._id === this.currentControlAccessCard.controllers[i]) != null) {
                  $('#selectedControllerUser' + this.currentControlAccessCard.controllers[i]).dropdown('set selected', this.currentControlAccessCard.controllers[i]);
                } else {
                  this.currentControlAccessCard.controllers.splice(i, 1);
                  i--;
                }
              }

              $('.ui.dropdown').dropdown();
            });
          } else {
            this.controllersOfUser = this.allControllers;
          }
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.userForm.Hay_un_error_obtener_datos_usuario'),
          text: e
        });
      });
    },
    onChangeSelectUser: function () {
      this.controllersOfUser = [];

      if (this.currentControlAccessCard.usuarioSistema !== "0") {
        if (this.controllersByUsers[this.currentControlAccessCard.usuarioSistema] != null) {
          for(const controllerOfUser of this.controllersByUsers[this.currentControlAccessCard.usuarioSistema]) {
            const user = this.allControllers.find((u) => u._id === controllerOfUser);

            if (user != null) {
              this.controllersOfUser.push(user);
            }
          }
        }
      } else {
        this.controllersOfUser = this.allControllers;
      }

      this.controllersOfUser.sort((c1, c2) => {
        if (c1.description < c2.description) {
          return -1;
        } else if (c1.description > c2.description) {
          return 1;
        } else {
          return 0;
        }
      });

      this.currentControlAccessCard = Object.assign({}, this.currentControlAccessCard);
    },
    addAccesoSala: function () {
      this.currentControlAccessCard.controllers.push(parseInt(Math.random() * 1000000));

      Vue.nextTick(() => {
        $('.ui.dropdown').dropdown();
      });
    },
    removeAccesoSala: function (idController) {
            this.currentControlAccessCard.controllers = this.currentControlAccessCard.controllers.filter((c) => c !== idController);
    },
    save: function () {
      if (this.currentControlAccessCard.usuarioSistema == null || this.currentControlAccessCard.usuarioSistema === '0') {
        if (this.currentControlAccessCard.description.length === 0) {
          this.$swal.fire({ type: 'error', title: this.$i18n.t('components.common.Error'), text: this.$i18n.t('components.userForm.Introducir_descripcion') });
          return;
        }
      }

      if (this.currentControlAccessCard.userid.length <= 0) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('components.common.Error'), text: this.$i18n.t('components.userForm.Introducir_userid') });
        return;
      }

      if (this.currentControlAccessCard.usuarioSistema == null) {
        this.$swal.fire({ type: 'error', title: this.$i18n.t('components.common.Error'), text: this.$i18n.t('components.userForm.Seleccionar_usuario_sistema') });
        return;
      }

      // obtenemos la fecha de caducidad
      if ($('#fecha-caducidad').calendar('get date') != null) {
        this.currentControlAccessCard.caducidad = this.moment($('#fecha-caducidad').calendar('get date')).valueOf();
      } else {
        this.currentControlAccessCard.caducidad = undefined;
      }

      // obtenemos la lista de controladores (descartando los no seleccionados y los repetidos)
      const newControllers = [];
      for (let i = 0; i < this.currentControlAccessCard.controllers.length; i++) {
        const idController = (($('#selectedControllerUser' + this.currentControlAccessCard.controllers[i]).val() == null) || ($('#selectedControllerUser' + this.currentControlAccessCard.controllers[i]).val() === 0)) ? null : $('#selectedControllerUser' + this.currentControlAccessCard.controllers[i]).val();
        const selectedController = this.controllersOfUser.find((c) => c._id === idController);

        if ((selectedController != null) && (newControllers.find((c) => c._id === selectedController._id) == null)) {
          newControllers.push(selectedController._id);
        }
      }
      this.currentControlAccessCard.controllers = newControllers;

      if (this.currentControlAccessCard._id != null) {
        axios.put('/controlAccessCard/' + this.currentControlAccessCard._id, this.currentControlAccessCard).then(response => {
          this.$swal.fire(
            this.$i18n.t('components.userForm.Save_Ok_Title'),
            this.$i18n.t('components.userForm.Save_Ok_Text'),
            'success'
          );

          this.$router.push({ name: 'controlAccessCards' });
        }).catch(e => {
          if (e.response.status === 400) {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.common.Error'),
              text: this.$i18n.t('components.userForm.Hay_un_error_userid_repetido')
            });
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.userForm.Hay_un_error_actualizar_datos_usuario'),
              text: e
            });
          }
        });
      } else {
        axios.post('/controlAccessCard', this.currentControlAccessCard).then(response => {
          this.$swal.fire(
            this.$i18n.t('components.userForm.Save_Ok_Title'),
            this.$i18n.t('components.userForm.Save_Ok_Text'),
            'success'
          );

          this.$router.push({ name: 'controlAccessCards' });
        }).catch(e => {
          if (e.response.status === 400) {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.common.Error'),
              text: this.$i18n.t('components.userForm.Hay_un_error_userid_repetido')
            });
          } else {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.userForm.Hay_un_error_actualizar_datos_usuario'),
              text: e
            });
          }
        });
      }
    }
  },
  mounted: function () {
    this.refresh();

    setTimeout(() => {
      $('.accordion').accordion({
        exclusive: false,
        selector: {
          trigger: '.title'
        }
      });

      $('.ui.dropdown').dropdown();
    }, 500);
  }
};
</script>
